<template>
<div>
  <div class="macro-bar-container" v-if="chartType === 'bar'" @click="togglePercentage">
    <div class="macro-row-wrapper">
      <div class="bar-col carbs" :style="`width: ${formattedMacro('carbs').percent}`" v-if="formattedMacro('carbs').unit !== '0g'">
        <span class="macro-label">C</span>
        <span class="bar-carbs"></span>
        <span class="unit" v-if="this.showPercentage">{{ formattedMacro('carbs').percent }}</span>
        <span class="unit" v-else>{{ formattedMacro('carbs').unit }}</span>
      </div>

      <div class="bar-col protein" :style="`width: ${formattedMacro('protein').percent}`" v-if="formattedMacro('protein').unit !== '0g'">
        <span class="macro-label">P</span>
        <span class="bar-protein"></span>
        <span class="unit" v-if="this.showPercentage">{{ formattedMacro('protein').percent }}</span>
        <span class="unit" v-else>{{ formattedMacro('protein').unit }}</span>
      </div>

      <div class="bar-col fat" :style="`width: ${formattedMacro('fat').percent}`" v-if="formattedMacro('fat').unit !== '0g'">
        <span class="macro-label">F</span>
        <span class="bar-fat"></span>
        <span class="unit" v-if="this.showPercentage">{{ formattedMacro('fat').percent }}</span>
        <span class="unit" v-else>{{ formattedMacro('fat').unit }}</span>
      </div>
    </div>
  </div>

  <h4 class="section-title" v-if="chartType === 'table'">{{ this.title }}</h4>
  <div class="macro-list-wrapper" v-if="chartType === 'table'">
    <div class="macro-row header">
      <span>Carbs</span>
      <span>Protein</span>
      <span>Fat</span>
    </div>
    <div class="macro-row">
      <span>{{ formattedMacro('carbs').unit }}</span>
      <span>{{ formattedMacro('protein').unit }}</span>
      <span>{{ formattedMacro('fat').unit }}</span>
    </div>
    <div class="macro-row">
      <span>{{ formattedMacro('carbs').percent }}</span>
      <span>{{ formattedMacro('protein').percent }}</span>
      <span>{{ formattedMacro('fat').percent }}</span>
    </div>
  </div>
</div>
</template>

<script>
import store from '@state/store';

export default {
  components: {},
  props: {
    chartType: {
      type: String,
      default: 'bar',
    },
    isEmbed: {
      type: Boolean,
    },
    macros: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: 'Macro Totals',
    },
  },
  data() {
    return {
      showPercentage: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    formattedMacro(type) {
      const macros = this.macros.macroNutritionDigest;
      return {
        unit: macros[type] ? `${macros[type].value}${macros[type].unit}` : '0g',
        percent: macros[type] ? `${macros[type].macroPercentage}%` : '0%',
      };
    },
    togglePercentage() {
      this.showPercentage = !this.showPercentage;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.section-title {
  margin-bottom: 1rem;
}

.macro-bar-container,
.macro-list-wrapper {
  background-color: transparent;
  border: none;
  border-radius: $base-border-radius;
  font-size: 1.2rem;
}

// MACRO BAR

.macro-row-wrapper {
  display: flex;
  justify-content: space-around;
  padding: 1rem;
}

.macro-bar-container {
  padding: 0.5rem 3rem;

  :hover {
    cursor: pointer;
  }

  .bar-col {
    display: flex;
    flex-direction: column;
    text-align: center;
    transition: width 250ms cubic-bezier(0.64, 0.57, 0.67, 1.53);

    &.carbs {
      width: 0%;
    }

    &.protein {
      width: 0%;
    }

    &.fat {
      width: 0%;
    }

    .macro-label {
      font-weight: bold;
    }

    .bar-carbs,
    .bar-protein,
    .bar-fat {
      height: 0.5rem;
      margin: 0.5rem 0;
    }

    .bar-carbs {
      background-color: $color-carbs;
      border-bottom-left-radius: $base-border-radius;
      border-top-left-radius: $base-border-radius;
      width: 100%;
    }

    .bar-protein {
      background-color: $color-protein;
      width: 100%;
    }

    .bar-fat {
      background-color: $color-fat;
      border-bottom-right-radius: $base-border-radius;
      border-top-right-radius: $base-border-radius;
      width: 100%;
    }

    .unit {
      font-size: 1.3rem;
      font-weight: bold;
    }
  }
}

// MACRO LIST

.macro-list-wrapper {
  margin-bottom: 2rem;

  .macro-row {
    display: flex;
    justify-content: space-around;
    padding: 1rem;

    &:not(:last-child) {
      border-bottom: 1px solid $base-border-color;
    }

    &.header {
      font-size: 1.3rem;
      font-weight: bold;
    }
  }
}
</style>
